import colors from '@/styles/map.scss';
// 定义roi中各元素所占的uv高度
export var EnumRoiUvH;
(function (EnumRoiUvH) {
    EnumRoiUvH[EnumRoiUvH["roi"] = 0] = "roi";
    EnumRoiUvH[EnumRoiUvH["border"] = 0.1] = "border";
    EnumRoiUvH[EnumRoiUvH["park"] = 0.2] = "park";
    EnumRoiUvH[EnumRoiUvH["wall"] = 1] = "wall";
})(EnumRoiUvH || (EnumRoiUvH = {}));
export const UVConfig = {
    roi: EnumRoiUvH.roi,
    border: EnumRoiUvH.border,
    park: EnumRoiUvH.park,
    wall: EnumRoiUvH.wall,
};
const WALL_HEIGHT = 10;
const baseRoiConfig = {
    roiColor: colors.roiColor,
    isRoi: false,
    roiOpacity: 0.5,
    borderColor: colors.roiBorder,
    borderWidth: 0.5,
    isBorder: false,
    wallColor: colors.roiWall,
    wallHeight: WALL_HEIGHT,
    wallOpacity: 0.85,
    isWall: false,
    isPark: false,
    parkColor: colors.park,
    parkWidth: 3,
    lineOpacity: 0.85,
    color: colors.lightLine,
    isAnimation: false,
    isShowMoveLine: false,
    isMoveLineAutoOpacity: true,
    isTwill: false, // 斜纹，注意：原有光带将失效
};
// 普通roi
export const roiConfig = {
    ...baseRoiConfig,
    isRoi: true,
    wallHeight: 0,
};
// 带波纹光栅
export const fenceConfig = {
    ...baseRoiConfig,
    isWall: true,
    isShowMoveLine: true,
    isAnimation: true,
};
// 条纹
export const stripeConfig = {
    ...baseRoiConfig,
    isWall: true,
    isShowMoveLine: true,
    isMoveLineAutoOpacity: false,
    isAnimation: true,
};
// 斜纹
export const twillConfig = {
    ...baseRoiConfig,
    isWall: true,
    isTwill: true,
    isAnimation: true,
};
export var ERoiType;
(function (ERoiType) {
    ERoiType["ROI"] = "roi";
    ERoiType["FENCE"] = "fence";
    ERoiType["STRIPE"] = "stripe";
    ERoiType["TWILL"] = "twill";
})(ERoiType || (ERoiType = {}));
export const getRoiConfig = (type) => {
    const config = {
        roi: roiConfig,
        fence: fenceConfig,
        stripe: stripeConfig,
        twill: twillConfig,
    };
    return config[type] || config.roi;
};
